import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter_line",
  "use": "icon-filter_line-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter_line\">\r\n<g clip-path=\"url(#icon-filter_line_clip0_114_786)\">\r\n<path d=\"M14.5728 1.75391H1.42676L6.45819 7.73434V14.7649H9.54121V7.73434L14.5728 1.75391Z\" stroke=\"currentColor\" stroke-width=\"1.5\" />\r\n</g>\r\n<defs>\r\n<clipPath id=\"icon-filter_line_clip0_114_786\">\r\n<rect width=\"16\" height=\"16\" fill=\"white\" />\r\n</clipPath>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol